export default {
    404: "Ошибка 404!! Страница недоступна.",
    title_404: "Страница, на которую вы пытаетесь перейти, недоступна",
    btn_404: "Назад",
    profilePosition: "Пользователь",
    manageScreenQuestion: "Вопрос",
    manageScreenLocation: "Описание локации",
    manageSetAsset: "Идентификатор",
    manageSetGeolocation: "Установить геолокацию",
    manageGeolocation: "Геолокация",
    manageUpdateBtn: "Обновить",
    manageLatitude: "Широта",
    manageLongitude: "Долгота",
    manageGPSAccuracy: "Точность GPS {v1}м",
    manageGPSLocation: "Местоположение по GPS",
    manageGPSAllowText: "Пожалуйста разрешите air-vote.com получать данные о местоположении GPS с вашего телефона",
    manageGPSAllowSubtitle: "мы будем использовать данные только тогда, когда вы посетите эту страницу, чтобы обновить геолокацию вопроса",
    manageGPSPopupLongDistance: "Ваши текущие координаты GPS далеко от предыдущего места размещения стикера ({v1}м)",
    manageGPSPopupBadAccuracyAndLongDistance: "Ваши текущие координаты GPS далеко от предыдущего места размещения стикера ({v1}м) и имеют низкую точность ({v2}м)",
    manageGPSPopupBadAccuracy: "Ваши текущие координаты GPS имеют низкую точность ({v1}м)",
    manageGPSPopupSureNewCoords: "Вы уверены, что хотите использовать новые координаты?",
    manageGPSPopupUseNewCoordsBtn: "Использовать новые координаты",
    manageGPSPopupChangeManuallyBtn: "Изменить вручную",
    manageMapBtn: "Использовать эту локацию",
    manageSaved: "Сохранено",
    manageCopiedToClipboard: "Скопировано в буфер обмена",
    manageGPSUnableToFetchMsg: "Мы не смогли получить ваше местоположение. Пожалуйста, попробуйте еще раз",
    manageGPSUnavailable: "GPS данные недоступны. Пожалуйста, проверьте ваши настройки и повторите позже",
    manage_back_to_yard: "Back to yard",
    admin_RemoveItem: "Удалить {v1}",
    admin_AddItem: "Добавить {v1}",
    admin_Admin: "Администратор",
    admin_Owner: "Контакт",
    admin_Client: "Клиент",
    admin_Votes: "Голоса",
    admin_Profiles: "Профили",
    admin_Organizations: "Организации",
    admin_showAllPlaces: "Показать все места",
    admin_SaveRole: "Сохранить роль",
    admin_deleteRole: "Удалить профиль {v1} {v2} ?",
    admin_deleteVote: "Удалить голос к вопросу \"{v1}\"",
    admin_deletePlace: "Удалить место \"{v1}\" ?",
    admin_deleteOrganization: "Удалить организацию \"{v1}\" ?",
    admin_deletePlaceWarning: "** Все связанные голоса будут удалены **",
    admin_successMessageAddOwner: "Владелец добавлен",
    admin_successMessageAddPlace: "Место добавлено",
    admin_successMessageRemoveOwner: "Владелец удален",
    admin_successMessageRemovePlace: "Место удалено",
    admin_successMessageRemoveVote: "Голос удален",
    admin_successMessageRemoveOrganization: "Организация удалена",
    admin_successMessageSaveOrganization: "Организация cохранена",
    admin_successMessageChangeRole: "Роль изменена",
    admin_Stickers: "Стикеры",
    admin_ChangeStatusToCancelled: "Изменить статус на «Отменен»?",
    admin_ChangeStatusToSent: "Изменить статус на «Отправлено»?",
    admin_ChangeStatusToCompleted: "Изменить статус на «Выполнено»?",
    admin_adminVotesShowAll: "Включительно с нашими",
    admin_searchByName: "Поиск по имени",
    admin_signInAs: "Войти как: {v1}?",
    admin_ReturnToOriginalAccount: "Вернуться к изначальному аккаунту: {v1}?",
    admin_closeAccountRequests: "Запросы на закрытие аккаунта",
    admin_landingQuestions: "Вопросы на сайте",
    admin_firstName: "Имя",
    admin_lastName: "Фамилия",
    admin_contactEmail: "Контактный email",
    admin_phone: "Номер",
    admin_success: "Успех",
    admin_userCreated: "Создан новый юзер",
    admin_sortBy: "Сортировать по",
    admin_sortByName: "Имени",
    admin_sortByAdded: "Добавленному",
    admin_sortByUpdated: "Обновлению",
    admin_sortByEmail: "Почте",
    admin_sortByCreated: "Созданию",
    adminPanel: "Админ панель",
    admin_Add: "Добавить",
    admin_Places: "Места",
    admin_UnQuestions: "Вопросы",
    admin_ChooseYourPlace: "Выберете Ваше Место",
    admin_NothingFound: "Ничего не найдено",
    admin_Delete: "Удалить",
    admin_delete_image: "Вы хотите удалить изображения?",
    admin_successImageDelete: "Изображение было удалено",
    Track_vote: "Следите за Вашими оценками",
    Logout: "Выход",
    Sync_status: "Статус синхронизации",
    Success: "Успешно",
    Error: "Ошибка",
    Back: "Назад",
    Thank_for_vote: "Спасибо за Ваш голос. Желаете посмотреть Ваши оценки? Войдите при помощи",
    No_votes: "У вас ещё нет голосов",
    statusMessage: "Секунду...",
    Save: "Сохранить",
    ResetChanges: "Сбросить изменения",
    sign_in_to_connect: "Пожалуйста, войдите, чтобы подключить этот QR-код к Вашей компании",
    yes: "Да",
    no: "Нет",
    YourVotes: "Ваши голоса",
    OtherVotes: "Голоса других пользователей",
    sendAlertEvery: "Отправлять оповещение каждые",
    checkboxSoSo: "Так себе",
    checkboxHappy: "Хорошо",
    checkboxSad: "Плохо",
    AirVotes: "Всего голосов",
    Change: "Изменить",
    Submit: "Отправить",
    Cancel: "Отмена",
    CancelRequest: "Запрос был отменен",
    ChangedYourMind: "Передумали? Выберите новую оценку! Начальные дата и время останутся те же.",
    NotConnectedPlaceToAirVote: "Это место в настоящее время не привязано к AirVote",
    From: "От",
    To: "До",
    writeFeedBack: "Оставить отзыв (опционально)",
    voteSuccessText_1: "Cпасибо, Ваш голос отправлен!",
    voteSuccessText_2: "Хотите изменить голос? Нажмите на другой смайлик.",
    voteSuccessText_3: "Есть что сказать? Можете оставить отзыв",
    feedbackTitle: "Оставьте свой отзыв",
    feedbackTitleSoSo: "Что стоит улучшить?",
    feedbackTitleSad: "Подскажите, что не так?",
    feedbackSubtitle: "Только менеджеры бизнеса увидят его",
    yourNote: "Ваш коментарий",
    commentPopupEmail: "Введите email или номер телефона",
    feedbackText: "Я бы хотел, чтобы со мной связались",
    feedbackHelpText: "Владелец компании получит его, чтобы связаться с вами",
    writeAReview: "Публичный отзыв",
    writeAReviewTitle: "Вы можете оставить отзыв для {v1} тут:",
    bflow_BusinesConnectQuestion: "Пожалуйста, выберите свой бизнес для подключения вопроса \"{v1}\"",
    bflow_BusinesConnectQuestionSuccess: "Вопрос привязан успешно",
    bflow_ChoosePlace: "Пожалуйста, выберите место для подключения вопроса \"{v1}\"",
    bflow_AddQuestionSuccess: "Вопрос добавлен",
    bflow_BecameOwnerPlace: "Готово.  Вы сейчас контакт для \"{v1}\"",
    bflow_BecameOwnerPlaceConfirm: "Обозначить Вас как контакт для \"{v1}\"?",
    bflow_ConfirmConnectQuestionToPlace: "Добавить вопрос \"{v1}\" к заведению \"{v2}\"?",
    bflow_ConfirmConnectQuestionToPlacebelow: "Добавить вопрос \"{v1}\" к заведению ниже?",
    bflow_ConnectedQuestion: "Привязка вопроса",
    bflow_finishBusinesFlow: "Вы уверены, что хотите выйти?",
    bi_Name: "Имя",
    bi_OfficialName: "Название огранизации",
    bi_ContactEmail: "Электронная почта",
    bi_Phone: "Телефон",
    bi_Password: "Пароль",
    bi_Edit: "Редактировать",
    bi_Address: "Адрес",
    bi_WebsiteUrl: "Веб-сайт",
    bi_validation_OrganizationRequired: "Поле Название огранизации обязательно для заполнения",
    bi_validation_Email: "Некорректный формат email",
    bi_validation_Phone: "Некорректный формат телефону",
    bi_validation_Website: "Некорректный формат веб-сайту",
    bi_first_Name: "Имя",
    bi_last_Name: "Фамилия",
    bi_confirm_email: "Электронный адрес не подтвержден",
    bi_resend_email: "Отправить письмо для авторизации повторно",
    bi_resend_email_success: "Email для подтверждения был отправлен повторно",
    bi_change_password: "Изменить пароль",
    bi_set_password: "Установить пароль",
    bi_cancel_password: "Отменить изменение пароля",
    bi_current_password: "Действующий пароль",
    bi_retype_password: "Повторите новый пароль",
    bi_new_password: "Новый пароль",
    bi_save_password: "Сохранить новый пароль",
    bi_password_change_success: "Пароль успешно изменен",
    bi_confirm_new_password: "Подтвердите пароль",
    own_use_w3w: "Использовать what3words для геолокации",
    own_email_Confim: "Пожалуйста, подтвердите адрес вашей электронной почты",
    own_anyConnectedPlace: "У вас еще нет подключенного места",
    own_myQuestions: "Мои вопросы",
    own_createQuestion: "Создать вопрос",
    own_orderStickers: "Заказать наклейки",
    own_selectRange: "Выберите диапазон",
    own_today: "Cегодня",
    own_last7days: "Последние 7 дней",
    own_lastMonth: "Прошлый месяц",
    own_allTime: "Все время",
    own_custom: "Произвольно",
    own_Search: "Поиск",
    own_showMore: "Показать больше",
    own_showLess: "Показать меньше",
    own_Locations: "Места",
    own_Questions: "Вопросы",
    own_Total: "Сумарно",
    own_Happy: "Супер",
    own_SoSo: "Так себе",
    own_Sad: "Плохо",
    own_green: "Зеленый",
    own_yellow: "Желтый",
    own_red: "Красный",
    own_EditQuestion: "Редактировать вопрос",
    own_DownloadPDF: "Скачать PDF",
    own_DownloadPDFMobile: 'Скачать PDF',
    own_OrderSticker: "Заказать стикер",
    own_DeleteQuestion: "Удалить вопрос",
    own_DownloadAndPrint: "Скачать и распечатать",
    own_OrderStickerFrom: "Заказать стикер от AirVote",
    own_DeliveryAddress: "Введите адрес доставки",
    own_RecipientName: "Имя получателя",
    own_RecipientPhone: "Телефон получателя",
    own_RecipientEmail: "Email получателя",
    own_Comment: "Комментарий",
    own_ShowZeroVotes: "Вопросы без отзывов",
    own_CreateNew: "Создать новый вопрос AirVote",
    own_EnterQuestion: "Введите свой вопрос AirVote здесь",
    own_SpecifyLocation: "Укажите местоположение",
    own_DownloadPDF_Title: "Вопрос добавлен",
    own_DownloadPDF_Description: "Теперь вы можете скачать PDF стикер с вопросом",
    own_DownloadPDF_EditTitle: "Вы успешно отредактировали вопрос!",
    own_SureTODelete: "Вы уверены, что хотите удалить свой вопрос?",
    own_DownloadSticker: "Скачать стикер в PDF",
    own_StickerProportion: "Выберите макет стикера, который соответствует вашим требованиям",
    own_PanelTextLeaflet: "Компакт",
    own_PanelTextBusiness: "Визитка",
    own_PanelTextExtended: "Стандарт",
    own_PanelSubtitleLeaflet: "Распечатайте как небольшую рекламную карточку для клиентов или поместите ее на обратной стороне визитной карточки",
    own_PanelSubtitleExtended: "Распечатайте в виде наклейки или листовки. Разместите их в пределах досягаемости клиентов",
    own_PanelSubtitleBusiness: "Более компактный дизайн для печати и распостранения в виде визитных карточек",
    own_AllVotesWillDeleted: "Все голоса по этому вопросу AirVote будут удалены",
    own_HasBeenDeleted: "Вопрос удален",
    own_DontForgetCreate: "Не забудьте создать новый!",
    own_Manage: "Управление",
    own_Title: "Добро пожаловать в бизнес-панель AirVote!",
    own_Business: "Ваш бизнес",
    own_Subitle: "Укажите название вашего бизнеса, чтобы создавать вопросы. Его можно будет изменить\nв любой момент",
    own_BusinessName: "Название вашего бизнеса",
    own_SaveBtn: "Сохранить и продолжить",
    own_SaveBtnWithQuestion: "Сохранить и получить мои QR-смайлики",
    own_CanNotFind: "Не могу найти свой бизнес",
    own_PleaseStartWriting: "Начните писать название своей компании и выберите его из раскрывающегося списка",
    own_Address: "Адрес",
    own_AssetId: "Идентификатор",
    AnalyticSettings: "Настройка аналитики",
    AnalyticDescription: "Этими настройками, вы настраиваете способ отображения данных на панели аналитики.",
    AnalyticIndex: "Индекс аналитики",
    AnalyticWhatMean: "Что это значит?",
    AnalyticWhatMeanIndex: "Почему Index - хорошая идея?",
    AnalyticWhatMeanIndexDescription: "Index обеспечивает объективную меру для отслеживания тенденций с течением времени и сравнения эффективности в разных областях.",
    AnalyticWhatMeanIndexValue: "Как AirVote рассчитывает значения Index:",
    AnalyticIndexPromouterScore: "・ Чистая оценка промоутера: # \"счастливых голосов\" * 100% + # \"так себе\" голосов * 0% - # \"грустных\" голосов * 100%. Наивысший балл - 100. Самый низкий балл -100.",
    AnalyticIndexAirVoteScore: "・ Оценка AirVote: # \"счастливых голосов\" * 100% + # \"так себе\" голосов * 50%. Наивысший балл - 100. Самый низкий балл - 0.",
    ThereIsAnError: "Введите корректное значение",
    StickerStatus: "Статус стикера",
    Requested: "Запрошен",
    Sent: "Отправлен",
    Cancelled: "Отменен",
    Close: "Закрыть",
    welcomeModalTitle: "Найдите вашу компанию или бизнес на карте",
    welcomeModalSubtitle: "Мы используем данные Google, чтобы помочь вам зарегистрировать вашу компанию в AirVote",
    welcomeModalSearchYouBusinass: "Найдите ваш бизнес с помощью поля ввода в верхней части экрана",
    welcomeModalPickOnMap: "Или выберите его на карте",
    welcomeModalNotOnGoogle: "Компании нет в Google? Проблемы с регистрацией?  Пишите нам на почту",
    mapTipsSearch: "Найдите ваш бизнес по его названию",
    mapTipsPick: "Или выберите его на карте",
    OK: "OK",
    Location: "Расположение",
    Question: "Вопрос",
    thankVoteTitle1: "Отзыв сохранен",
    thankVoteTitle2_1: "Спасибо за ваш отзыв",
    thankVoteTitle2_2: "Зарегистрируйтесь в AirVote, чтобы просматривать и изменять свои голоса",
    companyManagement: "Руководство фирмы",
    sites: "Отделения",
    site: "Отделение",
    SitesDescription: "Отделения - это разные филиалы или офисы вашей компании. Отделению может быть назначен один или несколько администраторов. Эти менеджеры могут редактировать детали отделениям и иметь доступ к аналитике отделения.",
    addNewSite: "Добавить отделение",
    siteDetail: "Детали отделения",
    questionsAndAnalytics: "Вопросы и аналитика",
    companyInformation: "Информация о компании",
    companyManagers: "Менеджеры компании",
    saveChanges: "Сохранить изменения",
    companyManagersDescription: "Вы можете назначить менеджеров компании, которые смогут редактировать любые данные о компании, а также управлять отделениями, назначать менеджеров отделений и других менеджеров компании.",
    Invite: "Приглашение",
    EnterEmailToAssignCompanyManager: "Введите email менеджера",
    enterSeveralEmailByComma: "Вы можете ввести несколько адресов электронной почты через запятую",
    Pending: "Ожидание",
    Accepted: "Принятый",
    Remove: "Удалить",
    ActiveManagers: "Активные менеджеры",
    NoOthersCompanyManagersAssigned: "Другие менеджеры компании не назначены",
    removeManager: "Удалить менеджера: {v1}?",
    all: "Все",
    editManagers: "Редактировать менеджеров",
    assignManagers: "Назначить менеджеров",
    viewAnalytic: "Просмотр аналитики",
    deleteSite: "Удалить отделение",
    deleteSiteConfirm: "Удалить отделение: {v1}?",
    siteManagers: "Менеджеры отделений",
    SiteManagersNotAssigned: "Не назначены",
    siteName: "Название отделения",
    siteAddress: "Ваш веб-сайт или ссылка на соцсеть",
    siteAddressSidebar: "Адрес",
    Website: "Вебсайт",
    Email: "Email",
    Alias: "Алиас",
    EditPhoto: "Редактировать фотографию",
    SitePhoto: "Фото отделения",
    AirVoteSuggestsTitle: "AirVote предлагает",
    SearchForQuestion: "Предложенные вопросы",
    UseQuestion: "Использовать этот вопрос",
    ImagesSupportedParams: "Изображения в форматах PNG и JPG поддерживаются. Максимальный размер фото 5 Мб",
    UploadFile: "Загрузить файл",
    RemovePhoto: "Удалить фото",
    RemovePhotoConfirm: "Вы уверены, что хотите удалить фотографию отделения?",
    RemovePhotoSuccess: "Фото успешно удалено",
    WrongFormat: "Неверный формат. Поддерживаются PNG или JPG",
    PhotoOverweight: "Фотография больше чем {v1}Мб",
    cancelInvite: "Отменить запрос: {v1}?",
    createSiteMap: "Создать новое отделение, используя это место: {v1}?",
    chooseNewPlaceFrOrganization: "Пожалуйста выберите новое место для вашей организации",
    MyBusinessIsMultipleSites: "Мой бизнес имеет несколько отделений",
    goingToMultipleSitesMode: "Запросить режим нескольких отделений для своей организации?",
    by_questions: "Вопросам",
    by_sites: "Отделениям",
    by_locations: "Местоположениям",
    groupBy: "Группировать по",
    Diagram: "Диаграмма",
    ID: "ID",
    Filter: "Фильтр",
    Comments: "Комментарии",
    ownLastVotes: "Последние отзывы",
    IndexAirvote: "Индекс AirVote",
    TotalVotes: "Всего",
    Notifications: "Уведомления",
    CloseAccount: "Закрыть мой аккаунт",
    DowngradeToClient: "Понизить меня до клиента",
    SendNotificationEach2: "отзывов",
    WithCommentsOnly: "с комментариями/фото/аудио",
    CommentsOnly: "Только комментарии",
    SMS: "СМС",
    Reports: "Отчеты",
    daily: "Ежедневно",
    weekly: "Еженедельно",
    monthly: "Ежемесячно",
    SendRequestToClose: "Отправить запрос на закрытие аккаунта?",
    SendRequestToRestore: "Отправить запрос на восстановление аккаунта?",
    RestoreAccount: "Восстановить аккаунт",
    ReturnBtn: "Назад",
    DowngradeProfileToClient: "Понизить аккаунт до роли клиента?",
    ProfileSettings: "Настройки профиля",
    savedSuccessfuly: "Сохранено успешно",
    Message: "Сообщение",
    NoData: "Нет данных",
    Decline: "Отклонить",
    Approve: "Утвердить",
    DeclineRequest: "Отклонить запрос на удаление аккаунта?",
    ApproveRequest: "Утвердить запрос на удаление аккаунта?",
    MyPlaces: "Мои места",
    EmptySiteTitle: "В вашей компании нет настроенных отделений. Добавить первое!",
    EmptySiteDescription: "Отделения - это разные филиалы или офисы вашей компании. В отделении может быть один или несколько администраторов. Они могут редактировать детали отделения и иметь доступ к аналитике отделения.",
    accountSettings: "Настройки аккаунта",
    accountSettingsDescription: "Изменить данные своего профиля, управлять уведомлениями и полученными отчетами",
    otherOptions: "Другие опции",
    UploadNewPhoto: "Загрузить новое фото",
    receiveBadVotesViaSms: "Вы можете получать уведомления про отзывы по электронной почте или SMS",
    Threshold: "Порог",
    SoSoVotes: "Так себе отзывы",
    Channel: "Канал",
    DisableAllNotifications: "Отключить все уведомления",
    EnableAllNotifications: "Включить все уведомления",
    sendDetailedReportToEmail: "Мы можем отправлять подробные отчеты на вашу электронную почту",
    Regularity: "Регулярность",
    nothingSelected: "Ничего не выбрано",
    allNotificationsDisabled: "Все уведомления отключены",
    createNewUser: "Создать нового пользователя",
    exportRawData: "Экспорт",
    exportTo: "Экспортировать в",
    w3wTitle: "Простой способ описать местоположение в любой точке мира",
    w3wLearnMore: "Узнать больше",
    unassignedQuestion: "Скрыть вопросы без местоположения",
    moreOptiosPopuoTitle: "Доп. опции",
    driverMainText: "У вашей учетной записи {v1} есть доступ только для управления местами размещения и местоположениями.\n" +
        "Используйте свой логин для управления, чтобы получить полный доступ к панели управления {v2}",
    own_filter_placeholder: "Введите для поиска",
    own_ExtPlacementEdit: "Редактировать",
    question_suggestions_freq_title: "Последние используемые",
    tab_Map: "Карта",
    smileysMailTitle: "Ваши смайлы AirVote QR уже в пути!",
    smileysMailSubtitle: "Проверьте {v1} - QR-смайлики уже там. Если вы не получите их в течение нескольких минут, проверьте папку \"Спам\" или",
    smileysMailDownload: "cкачайте здесь",
    smileysMailChecklist: "Теперь вы можете войти в свою бизнес-панель. Там вы можете:",
    smileysMailChecklistFirst: "Просмотреть отчеты об отзывах клиентов в режиме реального времени",
    smileysMailChecklistSecond: "Создать и распечатать дополнительные вопросы",
    smileysMailChecklistThird: "Настроить оповещения в реальном времени",
    smileysMailChecklistFourth: "Просмотреть расширенную статистику",
    smileysMailChecklistMore: "...и многое другое!",
    smileysMailChecklistBtn: "Перейти в бизнес-панель",
    smileysMailChecklistBack: "Вернуться на сайт",
    signIn_enter: "Войдите, используя",
    signIn_or: "или",
    signIn_difficulties: "Возникли трудности?",
    signIn_contact: "Свяжитесь с нами по адресу",
    signIn_signIn_title: "Вход",
    signIn_signUp_title: "Регистрация",
    signIn_enter_using_email: "или войдите, используя email",
    signIn_email_hint: "Email",
    signIn_password_hint: "Пароль",
    signIn_signInBtn: "Войти",
    signIn_forgotPass_btn: "Забыли пароль?",
    signIn_noCreditReq: "Платежные данные не требуются",
    signIn_firstName_hint: "Имя",
    signIn_lastName_hint: "Фамилия",
    signIn_signUp_btn: "Создать аккаунт",
    signIn_useMedia: "Или зарегистрируйтесь через соцсети",
    signIn_agreeTo: "Я принимаю",
    signIn_tAndC: "Условия пользования",
    signIn_recoverPassword: "Восстановление пароля",
    signIn_recoverPassSubtitle: "Введите email, который был использован при регистрации",
    signIn_recoverPassContinue: "Продолжить",
    signIn_recoverPassBack: "На страницу входа",
    signIn_codeAlreadyUsed: "Этот код для сброса пароля уже использован",
    signIn_protected: "Этот сайт защищен reCAPTCHA и применяются",
    signIn_privacyPolice: "Политика Конфиденциальности",
    signIn_and: "и",
    signIn_Terms: "Условия использования",
    signIn_Login: "Войти через {v1}",
    signIn_Register: "Регистрация через {v1}",
    signIn_RegisterWithEmail: "Зарегистрируйтесь с помощью электронной почты",
    signIn_RegisterWithQuestion: "Далее: О моем бизнесе",
    signIn_SeparatorText: "ИЛИ",
    signIn_TitleWithQuestion: "Зарегистрируйтесь в AirVote, чтобы:",
    signIn_ChecklistFirst: "Получить QR-смайлики по электронной почте",
    signIn_ChecklistSecond: "Получить доступ к панели вашего бизнеса и отслеживать отзывы",
    signIn_LookAtEmail: "Пожалуйста, посмотрите вашу электронную почту для получения подробной информации",
    resetPasswordRequestCancel: "Ваш запрос на сброс пароля был отменен",
    resetPasswordRequestAlreadyCanceled: "Сброс пароля уже отменен",
    changePasswordFormTitle: "Форма смены пароля",
    passwordDontMatch: "Пароли не совпадают",
    auth_confirm_email_confirming: "Подтверждение email'а 🔄",
    auth_confirm_email_confirmed: "Email подтвержден ✅\nПереход в бизнес-панель...",
    auth_confirm_email_already_confirm: "Ваш электронный адрес уже подтвержден",
    login_btn_link: "Войдите",
    login_btn_text: "в вашу бизнес-панель",
    giveawayBottom_title: "Нажмите, чтобы принять участие в розыгрыше подарочной карты!",
    giveawayBottomFinish_title: "Вас добавили в розыгрыш подарочной карты!",
    giveawayPopup_title: "УЧАСТВОВАТЬ В РОЗЫГРАШЕ ПОДАРОЧНОЙ КАРТЫ",
    giveawayPopup_login: "Войдите через Google или Facebook",
    giveawayPopup_review: "Оставьте отзыв на любой из cтраниц {v1}",
    giveawayPopup_entered: "Вы будите учавствовать в розыграше",
    giveawayPopup_BtnLogin: "Начните с авторизации",
    giveawayPopup_BtnReview: 'Оставить отзыв',
    giveawayPopup_cancel: 'Я не хочу участвовать',
    giveawayPopup_finalStep: 'Мы ценим ваш честный отзыв!\n\nВы были добавлены в наш розыгрыш.\n\nВернитесь и проголосуйте еще раз: каждый голос увеличивает ваши шансы!',
    giveawayPopup_proceedReview: "Перейти к отправке отзыва",
    password_validation_min_length: "Минимум 6 символов",
    password_validation_uppercase: "Одна заглавная буква",
    password_validation_lowercase: "Одна строчная буква",
    loadPdfProgress: "Создание PDF 🔄",
    showManagePopupTitle: 'Управляйте вопросами, скачивайте QR-смайлики',
    showManagePopupSubtitle: "Добро пожаловать в бизнес-панель AirVote! Каждый блок, который вы видите на экране, - это вопрос, который вы задали. Используйте значок для управления вопросами: редактируйте, удаляйте или загружайте QR-смайлики в формате PDF",
    showFeedbackPopupTitle: "Начните получать обратную связь",
    showFeedbackPopupSubtitle: "Когда вы получите свои QR-смайлики, разместите их так, чтобы клиенты могли видеть. Каждый отзыв сразу отображается на панели вашего бизнеса",
    showAlertsPopupTitle: "Настройте и получайте оповещения",
    showAlertsPopupSubtitle: "Поздравляем с получением первых отзывов! Знаете ли вы, что вы можете получать уведомления о любом отзыве по СМС и на электронную почту? Перейдите на страницу своего профиля для настройки уведомлений",
    helpCenterTitle: "Центр помощи",
    dataReportPopup: 'Данные отсутствуют. Выберите другой диапазон дат',
    dataReportPopupMobileXLSX: 'Этот файл будет содержать только основные данные. Для просмотра подробной аналитики и диаграмм голосования используйте панель управления AirVote на ПК или Mac',
    unsubscribeBtn: "Отписатся",
    unsubscribeSaveBtn: "Сохранить настройки",
    unsubscribePopupText: "Вы успешно отписались",
    orderBannerSubtitle: "Мы можем распечатать ваши вопросы на водонепроницаемом виниле и отправить в любую точку мира",
    orderBannerBtn: "Заказать стикеры",
    orderStickersBtn: "Заказать QR-стикеры",
    orderPageBtn: "Давайте начнем",
    orderSelectTitle: "Выберите вопросы, которые хотите распечатать",
    orderBusinessSite: 'Отделение',
    orderBusinessPlacement: 'Местоположение',
    orderTotal: 'Cумма заказа',
    orderDelivery: 'Доставка',
    orderDeliveryText: 'Бесплатно',
    orderFormTitle: 'Завершите ваш заказ',
    orderFormSubtitle: 'Ориентировочный срок доставки 10–15 дней',
    orderShippingTitle: 'Доставка за пределы США и Европы',
    orderShippingSubtitle: 'Свяжитесь с AirVote, чтобы получить цену заказа, включая все транспортные и таможенные сборы.',
    orderQuote: 'Рассчитать стоимость',
    orderSuccessPayment: 'Ваш заказ был успешно создан. Мы свяжемся с вами в ближайшее время и предоставим цену заказа.',
    orderSuccessPayPal: 'Ваш заказ был успешно оплачен. Наша команда обработает его и свяжется с вами в ближайшее время.',
    orderBtnToDashboard: 'Перейти на бизнес-панель',
    orderShippingBlockTitle: 'Информация о доставке',
    orderCountryLabel: 'Страна',
    orderStickerSizeLabel: 'Размер стикеров',
    own_votesNotFound: 'У вас отсутствуют недавные отзывы 😔\n\nПожалуйста, проверьте, что ваши вопросы AirVote размещены на местах',
    own_votesQuestion: 'Вопрос:',
    own_votesPlacement: 'Место:',
    own_votesPriorVotes: 'Предыдущие отзывы клиента:',
    own_votesUser: 'Пользователь:',
    own_votesComment: 'Комментарий:',
    own_votesContactInfo: 'Контактные данные:',
    bulkPlacement: 'Групповое редактирование местоположения',
    bulkPlacementPopupSavedQuestions: "Выбрано вопросов",
    bulkPlacementPopupSelectAll: "Выбрать все",
    bulkSuccessfulPlaceEdit: "Местоположение изменено",
    bulkInputPlaceHolder: "Новое местоположение",
    manageNotEnoughPermissions: "У вас недостаточно прав для управления данным вопросом. Пожалуйста, войдите с другого аккаунта, или запросите доступ для редактирования",
    showAllVotes: "Показать все недавние голоса",
    setupTelegramBtn: "Настроить Telegram Bot",
    copy: "Копировать",
    telegramPopupGroup: "Добавить бота в группу",
    telegramPopupPrivate: "Добавить бота в приватный чат",
    telegramPopupTitle: "Ваш Хеш",
    telegramHashAvailable: "Текущий хеш доступен в течение 1 часа",
    emailSignature: 'Электронные коммуникации',
    emailSignatureSubtitle: "Скопируйте / вставьте смайлы в свои электронные письма, электронные счета или любые онлайн-презентации",
    emailSignatureTitle: 'Как AirVote работает для вас?',
    emailSignatureClick: 'Нажмите на смайлик, чтобы оставить отзыв',
    emailSignatureCopyLink: 'Копировать ссылку',
    singleEmailSignaturePageTitle: 'Добавьте AirVote E-Smiley в свои сообщения',
    copied: 'Скопировано',
    airLeads: 'AirLeads',
    serviceLogs: 'Service logs',
    serviceLog: 'Service Log',
    airLeadSubmittedBy: 'Представленный:',
    airLeadChooseDriver: 'выбрать водителя',
    airLeadCompanyName: 'Название компании',
    airLeadSiteType: 'Тип сайта',
    airLeadOpportunity: 'Возможность',
    airLeadCustomer: 'Клиент',
    airLeadAdditionalNotes: 'Дополнительные заметки',
    airLeadMoreService: 'Больше услуг',
    airLeadMoreUnits: 'Больше единиц',
    airLeadSink: 'Раковина',
    airLeadCallThem: 'Позвонить им',
    airLeadSubmitALead: 'Отправить заявку',
    airLeadHideLeads: 'Скрыть закрытые заявки',
    airLeadShowAllLeads: 'Показать все заявки',
    airLeadDashboardDate: 'Дата',
    airLeadDashboardType: 'Тип',
    airLeadDashboardStatus: 'Статус',
    airLeadDashboardStatusNotes: 'Примечания к статусу',
    airLeadDashboardLastActionDate: 'Дата последнего действия',
    airLeadDashboardActionBy: 'Действия были сделаны',
    airLeadDashboardSalesFollowUp: 'Отслеживание продаж',
    airLeadDashboardNotClosed: 'Не закрыто',
    airLeadDashboardClosedWon: 'Закрыто/Выиграно',
    airLeadDashboardNotQualified: 'Неквалифицированный',
    airLeadDashboardCommission: 'Комиссия',
    airLeadDashboardNotLeadsFound: 'Ничего не найдено',
    airLeadDashboardRefresh: 'Обновить',
    airLeadInfoPopupDriver: 'Водитель',
    airLeadInfoPopupNotes: 'Примечания',
    airLeadInfoPopupLocation: 'Место расположения',
    airLeadInfoPopupViewOnMap: 'Посмотреть на карте',
    airLeadInfoPopupServices: 'Услуги',
    airLeadStatusAndCommissionError: 'Пожалуйста, введите статусные примечания и комиссию, чтобы закрыть сделку',
    airLeadStatusNotesError: 'Пожалуйста, введите примечания к статусу, чтобы закрыть сделку',
    airLeadNewCustomerLead: 'Новый клиент',
    airLeadExistingCustomer: 'Существующий клиент',
    airLeadPleaseChooseDriver: 'Пожалуйста, выберите водителя',
    airLeadPleaseCompanyInfo: 'Пожалуйста, введите информацию о компании',
    airLeadPleaseCustomerInfo: 'Пожалуйста, введите информацию о клиенте',
    airLeadGoodLack: 'Удачи на вашем пути! \nСпасибо за помощь в привлечении новых клиентов!',
    airLeadCommission: 'Комиссия должна быть больше 0',
    airLeadNumberShouldContains: 'Число должен содержать менее 3 цифр',
    sldPlaceGuid: "Гуид местоположения",
    sldOrganizationGuid: 'Гуид организации',
    sldGetPlaceConfig: 'Перезагрузить конфигурацию',
    sldEnableDetails: 'Включить детали проблемы',
    sldBasicConfig: 'Базовая конфигурация',
    sldScreenTitle: 'Заголовок экрана',
    sldScreenSubTitle: 'Подзаголовок экрана',
    sldScreenBackground: 'Цвет заднего фона:',
    sldMaxCount: 'Макс. количество выбранных элементов',
    sldEnterForUnlimited: 'Введите 0 для неограниченного количества',
    sldShowComment: 'Всегда показывать комментарий',
    sldBlocks: 'Блоки:',
    sldText: 'Текст',
    sldGreenScreen: 'Зеленый экран',
    sldYellowScreen: 'Желтый экран',
    sldRedScreen: 'Красный экран',
    sldOverrideSettings: 'Перезаписать базовые настройки',
    sldOverrideBlocks: 'Перезаписать базовые блоки',
    sldSecondLevelDetails: 'Детали второго уровня',
    configMissingMsg: 'Конфиг отсутствует, хотите его включить?',
    sldTakeFromPlace: 'Взять из отделения',
    sldChooseAnIcon: 'Выберите иконку',
    enableServiceLog: 'Включить журнала обслуживания',
    serviceLogRequirePin: 'Требуется пин-код?',
    serviceLogInfoPopup: 'Показать всплывающее окно с информацией о журнале обслуживания',
    serviceLogPlacementEdit : 'Показывать редактирование местоположения',
    sldEditIcon: 'Редактировать иконку',
    sldUploadIcon: 'Загрузить новую иконку',
    sldIconTag: 'Тег иконки',
    sldPleaseFillInput: 'Пожалуйста заполните поле',
    sldDefaultText: 'Текст по умолчанию',
    sldChooseIcon: 'Пожалуйста выберите иконку',
    sldSaveAndAddMore: 'Сохранить и продолжить',
    sldAddIcon: 'Добавить иконку',
    sldAreYouSure: "Вы уверенны что хотите удалить эту иконку?",
    commentViewOnMap: 'Посмотреть на карте',
    own_limitedAccessDialogTitle: "Ограниченный доступ",
    own_limitedAccessDialogBody: "Количество ваших отзывов превысило лимит бесплатного тарифа в месяц. Отзывов недоступно: {v1}.\nДля получения полного доступа, свяжитесь с командой AirVote",
    own_limitedAccessDialogContactBtn: "Связаться",
    own_limitedAccessText: "Количество ваших отзывов превысило лимит бесплатного тарифа в месяц. Отзывов недоступно: {v1}.\nДля получения полного доступа, свяжитесь с командой AirVote: {v2}",
    sldTagInUseErrorTitle: "Невозможно выполнить. Тег используется:",
    tab_AssetsMap: "Карта уборных",
    settings_checkbox_GoogleReviewAlerts: "Оповещения про Google отзывы",
    saving: "Сохранение",
}
